<template>
  <div>
    <v-container>
      <v-row align="center" class="text-center mt-12" v-if="!submitted">
        <v-col class="mb-4" cols="12">
          <h1 class="text-h2 mb-3 blue--text text--darken-3">Welcome.</h1>
          <h5 class="text-h5 grey-text">Let's see what services are available at your address.</h5>
        </v-col>
      </v-row>
      <v-row class="text-center justify-center mt-12" cols="12" v-if="!submitted">
        <v-col cols="3">
          <v-autocomplete
            shrink
            v-model="city"
            :items="cities"
            item-text="name"
            label="Choose your city"
            return-object
            clearable
            placeholder="Start typing to search"
            no-data-text="City not found"
          />
        </v-col>
      </v-row>
      <v-row class="text-center justify-center" v-if="city && !submitted">
        <v-col cols="3">
          <v-autocomplete
            shrink
            v-model="address"
            :items="addresses"
            item-text="address"
            label="Street address"
            placeholder="Start typing to search"
            no-data-text="Address not found"
            ref="addressAutocomplete"
            return-object
            clearable
          />
        </v-col>
      </v-row>
      <v-row class="text-center justify-center" v-if="city && address && !submitted">
        <v-col cols="3">
          <v-select
            shrink
            v-model="business"
            :items="businessSelections"
            label="Is this a residence or business?"
          />
        </v-col>
      </v-row>
      <v-row class="text-center justify-center" v-if="city && address && !submitted">
        <a @click="submit" class="blue--text text--darken-4">
          Check address
          <v-btn large icon class="text-center" color="blue darken-2">
            <v-icon class="icon-right">mdi-arrow-right-bold-circle</v-icon>
          </v-btn>
        </a>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row v-if="address && submitted">
        <v-col>
          <Services
            :address="address"
            :city="city"
            :business="business"
            @clearAddress="clearAddress"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Services from "./Services";

export default {
  name: "AddressLookup",

  components: { Services },

  mounted() {
    this.fetchCities();
  },

  data: () => ({
    address: null,
    addresses: [],
    business: false,
    businessSelections: [
      { text: "Residence", value: false },
      { text: "Business", value: true }
    ],
    cities: [],
    city: null,
    loading: false,
    submitted: false
  }),
  methods: {
    fetchAddresses() {
      if (!this.city) {
        this.addresses = [];
      }
      this.$axios
        .get("/api/cities/" + this.city.id + "/service-addresses")
        .then(({ data }) => {
          this.addresses = data.service_addresses;
        })
        .catch(() => {
          this.addresses = [];
        })
        .then(() => {
          this.loading = false;
        });
    },
    fetchCities() {
      this.$axios
        .get("/api/cities")
        .then(({ data }) => {
          this.cities = data;
        })
        .catch(() => {
          this.cities = [];
        })
        .then(() => {
          this.loading = false;
        });
    },
    clearAddress() {
      this.address = null;
      this.submitted = false;
    },
    submit() {
      this.submitted = true;
    }
  },
  computed: {},
  watch: {
    address() {
      if (this.address) {
        this.business = Boolean(this.address.business);
      }
    },
    city() {
      if (this.city) {
        this.fetchAddresses();
      }
    }
  }
};
</script>
